
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor/uaepass-auth",
      function () {
        return require("private-next-pages/vendor/uaepass-auth/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendor/uaepass-auth"])
      });
    }
  